import { getQuestionMethods } from '../_questions/getQuestionMethods';
import {
	AnyRenderedQuestion,
	GivenAnswers,
} from '../_questions/question.types';
import { matchConditions } from './matchConditions';

export const isQuestionAnswered = ({
	question,
	givenAnswers,
}: {
	question: AnyRenderedQuestion;
	givenAnswers: GivenAnswers;
}) => {
	const { isAnswered } = getQuestionMethods(question.type);

	return isAnswered({ question, givenAnswers });
};

export const getRelevantQuestions = (
	questions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
) => {
	const relevantQuestions: Array<AnyRenderedQuestion> = [];

	for (const question of questions) {
		const isQuestionRelevant = matchConditions({
			givenAnswers,
			allQuestions: questions,
			relevantQuestions,
			item: question,
		});

		if (isQuestionRelevant) {
			relevantQuestions.push(question);
		}
	}
	return relevantQuestions;
};

export const getCurrentQuestionId = (
	relevantQuestions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
	editingQuestionId: string | undefined,
) => {
	if (editingQuestionId != null) {
		return editingQuestionId;
	}

	const currentQuestion = relevantQuestions.find(
		(question) => !isQuestionAnswered({ question, givenAnswers }),
	);

	if (currentQuestion != null) return currentQuestion.id;

	return undefined;
};

export const getAnsweredQuestionIds = (
	relevantQuestions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
	currentQuestionId: string | undefined,
) => {
	return relevantQuestions
		.filter(
			(question) =>
				isQuestionAnswered({ question, givenAnswers }) &&
				question.id !== currentQuestionId,
		)
		.map((question) => question.id);
};

export const getRemainingQuestionIds = (
	relevantQuestions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
	currentQuestionId: string | undefined,
) => {
	return relevantQuestions
		.filter(
			(question) =>
				!isQuestionAnswered({ question, givenAnswers }) &&
				question.id !== currentQuestionId,
		)
		.map((question) => question.id);
};

export const getHasUnansweredQuestions = (
	questions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
) => {
	const relevantQuestions = getRelevantQuestions(questions, givenAnswers);
	const remainingQuestionIds = getRemainingQuestionIds(
		relevantQuestions,
		givenAnswers,
		undefined,
	);

	return remainingQuestionIds.length > 0;
};
